import { createFileRoute } from '@tanstack/react-router'
import EmployeeContracts from '@/features/employee-portal/pages/EmployeeContracts'

export const Route = createFileRoute('/_authenticated/employee-portal/contracts')({
  component: EmployeeContracts,
})


